import PropTypes from 'prop-types';
// @mui
import { Avatar, AvatarGroup, Box, Checkbox, Chip, FormControlLabel } from '@mui/material';
// utils
import { fShortenNumber } from '../../../utils/formatNumber';
// components
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../../components/Iconify';
import { setPostSearch } from '../../../redux/slices/blog/blog.post';

// ----------------------------------------------------------------------

BlogPostTags.propTypes = {
  tags: PropTypes.array.isRequired,
  statistic: PropTypes.object.isRequired,
  handleLike: PropTypes.func.isRequired,
};

export default function BlogPostTags({ tags, statistic, handleLike }) {
  const dispatch = useDispatch();
  const router = useRouter();

  const { search } = useSelector((state) => state.blogPost);

  const handleSelectTag = (value) => {
    let tags = [value];
    const tagIds = tags?.map((t) => t.id).toString();
    dispatch(setPostSearch({ ...search, page: 0, tags, filterBys: { ...search.filterBys, tagIds } }));
    router.push({ pathname: '/blogs' });
  };

  return (
    <Box sx={{ py: 3 }}>
      {tags?.map((tag) => (
        <Chip key={tag.id} label={tag.title} sx={{ m: 0.5 }} onClick={() => handleSelectTag(tag)} />
      ))}

      <Box sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
        <FormControlLabel
          control={
            <Checkbox
              onChange={handleLike}
              defaultChecked
              size="small"
              color="error"
              icon={<Iconify icon="eva:heart-fill" />}
              checkedIcon={<Iconify icon="eva:heart-fill" />}
            />
          }
          label={fShortenNumber(statistic?.likeNo)}
        />
        <AvatarGroup
          max={5}
          sx={{
            '& .MuiAvatar-root': { width: 32, height: 32 },
          }}
        >
          {statistic?.likers?.map((person) => (
            <Avatar key={person.displayName} alt={person.displayName} src={person.photoURL} />
          ))}
        </AvatarGroup>
      </Box>
    </Box>
  );
}
